module.exports = __webpack_public_path__ + "img/banner_newsDetail.b8be483f.jpg";